export default {
  // 外链详情
  getOuterLinkById: '/member/anonymous/amc/getOuterLinkById',
}